import React, { memo, useState, useEffect } from "react";

let remaining_time = 0;
const CountdownTimer = memo ( function CountdownTimer({
	time, sectionTimedOut,
	reduceSectionTime, setReduceSectionTime
}) {

	const [countdown, setCountdown] = useState(parseInt(parseFloat(time) * 60));
	const [id, setID] = useState(0);

	useEffect(() => {

		beginCountdown();
	}, []);

	useEffect(() => {
		if (countdown <= 0) {
			remaining_time = 0;
			clearInterval(id);
			setCountdown(0);
			sectionTimedOut();
		} else {
			remaining_time = countdown;
		}
	}, [countdown]);

	useEffect(() => {
		if (reduceSectionTime > 0) {
			if ((countdown - reduceSectionTime) <= 0) {
				setCountdown(0);
			} else {
				setCountdown(prev => (prev - reduceSectionTime));
			}
			setReduceSectionTime(0);
		}
	}, [reduceSectionTime]);


	const beginCountdown = () => {
		let interval_id = setInterval(() => {
			setCountdown(prev => (prev - 1));
		}, 1000);

		setID(interval_id);
	};

	const remainingTime = () => {
		return countdown;
	}

	return (
		<div className="timeRemaining">
			<p><i className="fa fa-clock-o"></i> <span>Time Remaining: {Math.floor(countdown / 60) +':'+ parseInt(countdown % 60)}</span></p>
		</div>
	);
});

export default CountdownTimer;
export { remaining_time };